import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_sidebar = _resolveComponent("the-sidebar")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.noSidebar)
      ? (_openBlock(), _createBlock(_component_the_sidebar, {
          key: 0,
          "is-opened": _ctx.isSidebarOpened,
          onOnToggleSidebar: _ctx.onToggleSidebar
        }, null, 8, ["is-opened", "onOnToggleSidebar"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(`main ${_ctx.noSidebar ? 'no-sidebar' : ''} ${_ctx.isSidebarOpened ? 'is-open' : ''}`)
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}